export default (color = '#ccc') => ({
    alignItems: 'center',
    display: 'flex',
    
    ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
    },
});